import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface ClearingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Clearing: React.FC<ClearingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [clearing, set_clearing] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Clearing'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Clearing': v } } })
    );
    const label = 'Clearing';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(clearing)}
                />
            ) : (
                <MoneyBox
                    id={'clearing'}
                    allowNegative={false}
                    value={clearing}
                    onChange={(value) => set_clearing(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
